import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'

/*
 * Prod configuration
 *
const firebaseConfig2019 = {
  apiKey: 'AIzaSyDzNgugXQi9mwfVZyxjcG6Wlkosug8UpCY',
  authDomain: 'sisredvolucion-61c11.firebaseapp.com',
  databaseURL: 'https://sisredvolucion-61c11.firebaseio.com',
  projectId: 'sisredvolucion-61c11',
  storageBucket: 'sisredvolucion-61c11.appspot.com',
  messagingSenderId: '264281232430',
  appId: '1:264281232430:web:f5ac84de715d647355fbbf',
  measurementId: 'G-WLVYTBYD22'
}

var firebaseConfig2020 = {
    apiKey: "AIzaSyBxqVCv39X0KB96WciwSQiTDKpJY4Ocllg",
    authDomain: "sisredvolucion2020.firebaseapp.com",
    databaseURL: "https://sisredvolucion2020.firebaseio.com",
    projectId: "sisredvolucion2020",
    storageBucket: "sisredvolucion2020.appspot.com",
    messagingSenderId: "838341759510",
    appId: "1:838341759510:web:8fb577c4a9b99a99099b37",
    measurementId: "G-SPJZ7GH3MF"
  };

*/

/**
 * Dev Configuration
 *
 */
var firebaseConfigDev = {
  apiKey: 'AIzaSyBxqVCv39X0KB96WciwSQiTDKpJY4Ocllg',
  authDomain: 'sisredvolucion2020.firebaseapp.com',
  databaseURL: 'https://sisredvolucion2020.firebaseio.com',
  projectId: 'sisredvolucion2020',
  storageBucket: 'sisredvolucion2020.appspot.com',
  messagingSenderId: '838341759510',
  appId: '1:838341759510:web:08a26074278914c7099b37',
  measurementId: 'G-6WEPCV54TT'
}
firebase.initializeApp(firebaseConfigDev)
export default firebase
